<template>
    <div class="list-container">
        <div class="table">
            <div class="row">
                <div class="cell"><a href="" class="point-up">Access For<span class="fa fa-angles-down"></span></a></div>
                <div class="cell"><a href="" class="point-down">Granted By <span class="fa fa-arrow-right"></span> Granted To</a></div>
                <div class="cell align-right"></div>
            </div>
            <div v-for="user in filteredUsers" :key="user.id" class="row">
                <div class="cell"><span class="fa" :class="userIcon(user)"></span> {{ userDisplayName(user) }}</div>
                <div class="cell">
                    <a v-if="!isOwner(user)" v-for="child in filterChildren(user)" :key="`user-${ user.id }-child-${ child.id }`" href="/tracker/behaviors/log">{{ grantedByUser(child) }} <span class="fa fa-arrow-right"></span> {{ child.first_name }} {{ child.last_name }}<br></a>
                    <span v-if="isOwner(user)">Access to All Children (Account Owner)</span>
                    <a v-if="user.children.length > 6" href @click.prevent="expandedChildren[ user.id ] = true">{{ user.children.length - 6 }} More - Click To Show</a>
                    <a v-if="!!expandedChildren[ user.id ]" href @click.prevent="expandedChildren[ user.id ] = false">Collapse</a>
                </div>
                <div class="cell align-right">
                    <div class="buttons">
                        <delete-button v-if="!isOwner(user) && user.pivot.status === 'ACTIVE'" text="Revoke" confirm-text="Confirm Revoke" @deleted="revoke(user)">
                            <a v-if="!isOwner(user) && user.pivot.status === 'ACTIVE'" :href="`/settings/connections/${ user.id }/edit`" class="neutral-bg">Update<span class="fa fa-link"></span></a>
                        </delete-button>
                        <a v-if="user.pivot.status === 'REVOKED'" :href="`/settings/connections/${ user.id }/reinstate`" class="good-bg">Reinstate<span class="fa fa-thumbs-up"></span></a>
                        <!--<a v-if="user.pivot.status === 'INVITED'"   href="" class="bad-bg">Cancel Invite<span class="fa fa-times-circle"></span></a>-->
                        <!--<a v-if="user.pivot.status === 'INVITED'"   href="" class="bad-bg">Cancel Invite<span class="fa fa-times-circle"></span></a>-->
                        <b v-if="user.pivot.status === 'INVITED'" class="neutral-text">Invited <span class="fa fa-envelope-open"></span></b>
                        <a v-if="user.pivot.status === 'INVITED'" :href="`/settings/connections/${ user.id }/resend`" class="good-bg">Resend Invitation<span class="fa fa-paper-plane"></span></a>

                    </div>
                </div>
            </div>
            <!--<div class="row">-->
                <!--<div class="cell"><span class="fa fa-times-circle"></span>Mary Poppins (Revoked)</div>-->
                <!--<div class="cell">Dale Appleseed</div>-->
                <!--<div class="cell">-->
                    <!--<a href="/tracker/behaviors/log">Parker Boone</a><br>-->
                    <!--<a href="/tracker/behaviors/log">Bentley Boone</a>-->
                <!--</div>-->
                <!--<div class="cell align-right">-->
                    <!--<div class="buttons"><a href="/settings/connections/edit" class="neutral-bg">Update<span class="fa fa-link"></span></a><a href="" class="good-bg">Reinstate<span class="fa fa-thumbs-up"></span></a></div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="row">-->
                <!--<div class="cell"><span class="fa fa-envelope"></span>mary@poppins.com (Invited)</div>-->
                <!--<div class="cell">You</div>-->
                <!--<div class="cell">-->
                    <!--<a href="/tracker/behaviors/log">Parker Boone</a><br>-->
                    <!--<a href="/tracker/behaviors/log">Bentley Boone</a>-->
                <!--</div>-->
                <!--<div class="cell align-right">-->
                    <!--<div class="buttons"><a href="" class="bad-bg">Cancel Invite<span class="fa fa-times-circle"></span></a></div>-->
                <!--</div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'underscore';

export default {

    props: [ 'users', 'account', 'grantedByUsers' ],

    data() {
        return {
            expandedChildren: {},
        };
    },

    computed: {

        ...mapState({
            user: state => state.user,
        }),

        filteredUsers() {
            return this.users;
        },

        owner() {
            return this.account.account_owner_id;
        },
    },

    methods: {

        isOwner(user) {
            return this.owner === user.id;
        },

        filterChildren(user) {
            if (!!this.expandedChildren[ user.id ]) return user.children;

            return user.children.slice(0, 6);
        },

        userDisplayName(user) {
            switch (user.pivot.status) {
                case 'ACTIVE':
                    return user.first_name + ' ' + user.last_name;
                case 'INVITED':
                    return user.email + ' (Invited)';
                case 'DECLINED':
                    return user.email + ' (Declined Invitation)';
                case 'REVOKED':
                    return user.first_name + ' ' + user.last_name + ' (Revoked)';
            }

            return 'Unknown';
        },

        userIcon(user) {
            switch (user.pivot.status) {
                case 'INVITED':
                    return 'fa-envelope';
                case 'DECLINED':
                case 'REVOKED':
                    return 'fa-times-circle';
            }

            return '';

        },

        revoke(user) {
            window.location.href = '/settings/connections/' + user.id + '/revoke';
        },

        grantedByUser(child) {
            if (child.pivot.granted_access_by_user_id === this.user.id) return 'You';

            const user = _.findWhere(this.grantedByUsers, { id: child.pivot.granted_access_by_user_id });

            if (user) {
                return user.first_name + ' ' + user.last_name;
            }

            return 'Unknown';
        }

    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/settings/connections/ConnectionList.vue